import type { PaymentOption } from '@/types/components';
import { addDays, parseLocalDate, startOfToday } from '@/utils/date';

const MAY_MONTH_INDEX = 4;
const LAST_DAY_OF_MAY = 31;

const getNextEndOfMay = (): Date => {
  const today = startOfToday();
  const isAfterMay = today.getMonth() > MAY_MONTH_INDEX;
  const year = today.getFullYear() + (isAfterMay ? 1 : 0);

  return new Date(year, MAY_MONTH_INDEX, LAST_DAY_OF_MAY);
};

export const getRecurringEndDates = ({
  recurringEndDate,
  recurringMaxEndDate,
}: PaymentOption) => ({
  defaultDate: recurringEndDate
    ? parseLocalDate(recurringEndDate)
    : getNextEndOfMay(),
  minDate: addDays(startOfToday(), 1),
  maxDate: recurringMaxEndDate
    ? parseLocalDate(recurringMaxEndDate)
    : getNextEndOfMay(),
});
